export const lang = {
    //公共
    document_title:'学术诚信风险指数',
    common_confirm:'确定',
    common_confirm_pay:'捐赠',
    common_no_data:'暂无数据',
    common_no_data_short:'暂无',
    common_msg_dialog_title:'温馨提示',
    common_msg_login_first:'请先登录',
    common_msg_not_allow_access_first:'尚未开通相关权限，请联系',
    //首页
    common_global_tip_title:'温馨提示',
    common_global_tip_confirm_known:'知道了',
    common_global_tip_confirm_ok:'好的',
    //顶部
    common_header_lang: "English",
    common_header_login: "机构登录",
    common_header_quit: "点击注销",
    common_header_ret_home: "点击返回首页",
    common_header_ret: "返回",
    common_header_login_prompt: "每日{0}次查询机会,请合理使用",
    common_header_remain_num: "剩余次数",
    common_header_pay: "捐赠",
    common_header_exit: "退出",

    //底部
    common_contact:'联系我们',
    common_email:'邮箱',
    common_phone:'电话',
    common_links_title:'友情链接',

    //登录注册
    //公共
    common_loginbox_input_email:'请输入邮箱',
    common_loginbox_input_pass:'请输入密码',
    common_loginbox_link_login_wechat:'微信登录',
    common_loginbox_link_reg:'点击注册',
    common_loginbox_link_find_pass:'找回密码',
    common_loginbox_link_login:'点击登录',
    //登录
    common_loginbox_login_title:'登录',
    common_loginbox_login:'登录',
    //注册
    common_loginbox_reg_title:'邮箱注册',
    common_loginbox_send_code:'发送验证码',
    common_loginbox_input_code:'请输入邮箱验证码',
    common_loginbox_reg:'注册',
    //找回密码
    common_loginbox_reset_title:'找回密码',
    common_loginbox_input_new_pass:'请输入新密码',
    // common_loginbox_confirm:'确认',
    //错误提示
    common_loginbox_err_email:'输入的邮箱格式不正确,请重新输入',
    common_loginbox_err_pass:'密码不合法,密码为6位以上数字字母组合',
    common_loginbox_err_code:'邮箱验证码不合法,验证码为4位字母或数字',
    //消息提示
    common_loginbox_msg_login_succ:'登录成功',
    common_loginbox_msg_login_fail:'登录失败,获取用户信息失败,请重试',
    common_loginbox_msg_send_limit:'发送邮件间隔限制,请稍等一会',
    common_loginbox_msg_reg_succ:'新用户注册提交成功,等待审核,审核成功后会下发邮件含邮箱和密码进行登录',
    common_loginbox_msg_reset_succ:'密码重置成功,自动登录成功',
    common_loginbox_msg_reset_succ_login_fail:'密码重置成功,自动登录失败,请尝试手动登录',
    common_loginbox_msg_reset_fail:'密码重置失败,请重试',
    common_loginbox_msg_send_email_fail:'发送邮件失败',
    common_loginbox_msg_send_email_succ:'发送邮件成功',
    common_loginbox_msg_code_err:'验证码错误,错误次数已达{0}次,还能重试次数{1}次',
    common_loginbox_msg_code_err_no_num:'验证码错误',
    common_loginbox_msg_login_gt_limit:'登录错误超过限制,请过会再试',
    common_loginbox_msg_login_user_in_black_list:'你的账号已被锁定,暂时无法登录使用',
    common_loginbox_msg_login_ip_in_black_list:'你的IP已被锁定,暂时无法登录使用',
    common_loginbox_msg_user_pass_err:'账号或密码错误,还能重试{0}次',
    common_loginbox_msg_user_not_exist:'用户可能不存在,请先注册',
    common_loginbox_msg_user_has_exist:'用户已存在,请登陆',
    common_loginbox_msg_reg_fail:'账号注册失败,请重新注册',
    common_loginbox_msg_logout_succ:'注销成功',
    //邮箱验证码
    common_email_titile:'邮箱验证码 by JCar',
    common_email_content:'你好，请将以下验证码 0000 输入至注册页面输入框，完成注册，谢谢。',

    pagination: {
        goto: '前往',
        pagesize: '条/页',
        total_prefix: '共',
        total_postfix:'条',
        pageClassifier: '页'
    },

    article_pub_date:"Publication Date",
    article_article_type:"Document Type",
    article_cited_num:"Citation Count",
    article_keyword:"Keywords",
    article_author:"Author",
    article_click_middle_author:"Click to Expand Middle Author",
    article_journal:"Journal",
    article_unpublish:"Unpublished",
    article_cas:"CAS ",
    article_cas_postfix:"",
    article_warning:"Warning",
    article_fisrt_collect:"First Inclusion",
    article_collect_time:"Collection Time",
    article_summary:"Abstract",
    article_expand_summary:"Expand Abstract",
    article_contraction_summary:"Contraction Abstract",
    article_zh_summary:"Chinese Abstract",
    article_en_summary:"English Abstract",
    article_summary_translating:"Translating Abstract…",
    article_click_retranslate:"Incorrect translation? Click to retranslate",
    article_reason:"Reason",

    valurev_conference_title:"大会致辞",
    valurev_conference_p1:"尊敬的各位审稿人、各位学界同仁，女士们、先生们：",
    valurev_conference_p2:"大家好！",
    valurev_conference_p3:"2026年11-12月，我们将齐聚苏州这座千年文化与现代活力交相辉映的城市，共同见证一个属于全球学术共同体崭新篇章的开启。我谨代表ValuRev以及所有合作伙伴出版社，并以大会主席的名义，向各位的到来表示最热烈的欢迎和最诚挚的感谢！",
    valurev_conference_p4:"我们正处于一个知识飞速迭代、创新层出不穷的时代。在这宏大的图景中，学术同行评议，如同基石一般，默默支撑着知识大厦的构建、守护着研究成果的质量与诚信。而诸位审稿人，正是这一体系中不可或缺的守护者与引路人。你们以卓越的学识、严谨的态度和无私的奉献，在浩如烟海的稿件中甄别真知，为研究的精进指明方向，是推动人类认知边界不断拓展的无名英雄。",
    valurev_conference_p5:"正是为了向这份至关重要的贡献致敬，并进一步强化学术交流的生态体系，ValuRev携手全球出版社伙伴，共同发起并创立了“ValuRev年度审稿人大会”。大会内容丰富，包括但不限于以下：",
    valurev_conference_p6:"相聚一堂：让平日里在屏幕后默默耕耘的审稿人与期刊主编们得以面对面交流，碰撞思想，凝聚共识；",
    valurev_conference_p7:"延揽英才：通过现场的编委会招募，审稿人可以更深入参与期刊发展，发挥作用；",
    valurev_conference_p8:"赋能提升：通过专业的审稿人培训会议，共享评审智慧，提升评审工作的效率与水平；",
    valurev_conference_p9:"彰显荣耀：隆重颁发“ValuRev年度审稿人”奖项，以荣誉和奖金，每年向20位展现出非凡贡献的审稿人致以最崇高的敬意。",
    valurev_conference_p10:"选择在苏州这座兼具古典底蕴与开放精神的东方水乡举办首届大会，寓意深远。我们期待，这里温润如玉的氛围能滋养深入的交流，这里贯通古今的智慧能启发未来的合作。",
    valurev_conference_p11:"此刻，我们不仅是开启一场会议，更是播种一颗希望的种子。我们期待，通过年复一年的努力，将这一大会打造成为连接全球学者、激励评审卓越、促进学术繁荣和科学传播的标志性殿堂。",
    valurev_conference_p12:"最后，预祝首届ValuRev年度审稿人大会圆满成功！祝愿大家在苏州度过一段充实而愉快的时光！",
    valurev_conference_p13:"谢谢大家！",
    valurev_conference_p14:"大会主席：",

    valurev_org_reg_01:"机构选择",
    valurev_org_reg_02:"（如果未匹配到名字，请直接输入。）",
    valurev_org_reg_03:"英文姓名",
    valurev_org_reg_04:"中文姓名",
    valurev_org_reg_05:"发表文献",
    // valurev_org_reg_06:"BRID号",
    valurev_org_reg_07:"学术邮箱",
    valurev_org_reg_08:"发送验证码",
    valurev_org_reg_09:"确认",
    valurev_org_reg_10:"提交成功，请等待本单位负责人确认，激活的ValuRev账号将通过邮件通知",
    valurev_org_reg_11:"返回",

    valurev_apc_01:"APC折扣权益简介",
    valurev_apc_02:"APC折扣指的是出版社在审稿人按要求14天完成某一篇审稿，并符合要求后。在审稿人向所在出版社以下期刊投稿，并最终接收后，给于APC版面费的折扣，不同出版社不同期刊折扣不同，折扣是否可以累加也有所不同。<b>支持折扣累加</b>",
    valurev_apc_03:"指的是如某位审稿人协助出版社审了5篇稿件，每篇稿件获得APC折扣20%，则该审稿人参加参与期刊投稿，则APC获得减免（20%*5=100%）。",
    valurev_apc_04:"/次"
}


